import React, { type JSX } from "react";
import { VerticalSpacing } from "../VerticalSpacing";
import { MediaEditingWrapper, PanelWithPreviewShowDestkop, PanelWithPreviewShowMobile, PreviewLabelWrapper } from "./V3PanelWithPreview.styles";
import { V3BodyGrey35 } from "../ReusableStyledComponents/V3BodyGrey35";
import { ItemPreview, ItemPreviewProps } from "../ItemPreview";
import { ContentItemPreviewLearnMore } from "../ReusableStyledComponents/ContentItemPreviewLearnMore";
import { ContentDetailType } from "@authory-packages/core";

interface V3PanelWithPreviewProps extends Omit<ItemPreviewProps, "isEmpty"> {
    showMediaPreview?: boolean;
    mainPanel: JSX.Element;
    btnPanel?: JSX.Element;
    previewEmpty?: boolean;
    hidePreviewLabel?: boolean;
    isBulkImport?: boolean;
    hidePreviewTitle?: boolean;
    isCollection?: boolean;
    contentDetailType?: ContentDetailType;
}

export const V3PanelWithPreview = ({
    title,
    description,
    imageSrc,
    showMediaPreview,
    mainPanel,
    showMetaContent = false,
    date,
    sourceName,
    contentDetailType,
    originalUrl,
    contentType,
    btnPanel,
    hidePreviewLabel = false,
    isBulkImport,
    hidePreviewTitle = false,
    isCollection = false
}: V3PanelWithPreviewProps) => {
    const isEmpty = !title?.length && !description?.length && !imageSrc?.length;
    const WrapperToUse = showMediaPreview ? MediaEditingWrapper : React.Fragment;
    const showPreviewLabel = showMetaContent && !hidePreviewLabel && !isEmpty;

    return (
        <WrapperToUse style={{ position: "relative" }}>
            <div>
                {mainPanel}
                <PanelWithPreviewShowDestkop>{btnPanel}</PanelWithPreviewShowDestkop>
            </div>
            {showMediaPreview && (
                <div style={{ marginTop: isBulkImport ? -35 : 0 }}>
                    <ItemPreview
                        date={date}
                        sourceName={sourceName}
                        originalUrl={originalUrl}
                        contentType={contentType}
                        contentDetailType={contentDetailType}
                        imageSrc={imageSrc}
                        title={title}
                        description={description}
                        showMetaContent={showMetaContent}
                        hidePreviewTitle={hidePreviewTitle}
                        isCollection={isCollection}
                    />
                    {showPreviewLabel && (
                        <VerticalSpacing top={28}>
                            <PreviewLabelWrapper>
                                <V3BodyGrey35>
                                    Preview of what the content will look like on your portfolio, in collections and when shared on social media.{" "}
                                    <ContentItemPreviewLearnMore />
                                </V3BodyGrey35>
                            </PreviewLabelWrapper>
                        </VerticalSpacing>
                    )}
                </div>
            )}
            <PanelWithPreviewShowMobile>{btnPanel}</PanelWithPreviewShowMobile>
        </WrapperToUse>
    );
};
